/* PUFFMART 速度改善4（2026-10-24）：トップの商品カルーセル（blocks/ai_gen_block_4d7ca94.liquid）の共通JS。
   以前は同じJS（約9KB）が11個のカルーセルごとにページへ直書きされていた。動き（自動送り・スワイプ・点・カート追加）は元と同じ。
   type="module" で読み込むので、ブロックが何個あってもブラウザは1回だけ実行する。 */
(function () {
  if (customElements.get('pm-ai-carousel')) return;

  class PuffmartCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-puffmart-track]');
      this.indicatorContainer = this.querySelector('[data-puffmart-indicator]');
      this.autoplayTimer = null;
      this.isUserInteracting = false;
      this.interactionTimeout = null;
      this.scrollIndex = 0;
    }

    connectedCallback() {
      if (!this.track) return;
      /* 画面に近づくまで初期化しない（ページ読み込み時の処理を軽くする） */
      if ('IntersectionObserver' in window) {
        this.pmIo = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.pmIo.disconnect();
            this.pmInit();
          }
        }, { rootMargin: '300px 0px' });
        this.pmIo.observe(this);
      } else {
        this.pmInit();
      }
    }

    pmInit() {
      if (this.pmReady) return;
      this.pmReady = true;
      this.cards = Array.from(this.track.querySelectorAll('[data-puffmart-card]'));
      this.totalCards = this.cards.length;
      if (this.totalCards === 0) return;

      this.setupCartForms();
      this.setupIndicator();
      this.setupScrollListener();
      this.setupInteractionListeners();
      this.updateIndicator();
      this.startAutoplay();
    }

    disconnectedCallback() {
      if (this.pmIo) this.pmIo.disconnect();
      this.stopAutoplay();
      clearTimeout(this.interactionTimeout);
    }

    /* ===== Ajax Add to Cart ===== */
    setupCartForms() {
      this.querySelectorAll('[data-puffmart-cart-form]').forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleAddToCart(form);
        });
      });
    }

    async handleAddToCart(form) {
      const btn = form.querySelector('[data-puffmart-add-btn]');
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      btn.classList.add('puffmart-loading');

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', { method: 'POST', body: formData });

        if (response.ok) {
          await response.json();
          this.updateCartCount();

          const textEl = btn.querySelector('.pmc__btn-text');
          if (textEl) {
            const original = textEl.innerHTML;
            textEl.innerHTML = '✓ 追加しました';
            btn.classList.remove('puffmart-loading');
            setTimeout(() => {
              textEl.innerHTML = original;
              btn.disabled = false;
            }, 1500);
          } else {
            btn.classList.remove('puffmart-loading');
            btn.disabled = false;
          }
        } else {
          const errorData = await response.json();
          console.error('puffmart cart error:', errorData.description || 'Add to cart failed');
          btn.classList.remove('puffmart-loading');
          btn.disabled = false;
        }
      } catch (err) {
        console.error('puffmart cart error:', err);
        btn.classList.remove('puffmart-loading');
        btn.disabled = false;
      }
    }

    updateCartCount() {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const selectors = [
            '.cart-count-bubble span[aria-hidden="true"]',
            '.cart-count-bubble',
            '#cart-icon-bubble span',
            '.header__cart-count',
            '[data-cart-count]',
            '.cart-count',
            '.js-cart-count'
          ];
          selectors.forEach((sel) => {
            document.querySelectorAll(sel).forEach((el) => {
              if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', cart.item_count);
              el.textContent = cart.item_count;
            });
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        })
        .catch(() => {});
    }

    /* ===== Carousel Logic ===== */
    getVisibleCount() {
      return window.innerWidth >= 750 ? 4 : 2;
    }

    getMaxIndex() {
      return Math.max(0, this.totalCards - this.getVisibleCount());
    }

    getCardStep() {
      if (!this.cards.length) return 0;
      const cardWidth = this.cards[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      return cardWidth + gap;
    }

    getCurrentCardIndex() {
      const step = this.getCardStep();
      if (step === 0) return 0;
      return Math.round(this.track.scrollLeft / step);
    }

    scrollToCard(index) {
      const maxIdx = this.getMaxIndex();
      index = Math.max(0, Math.min(index, maxIdx));
      const step = this.getCardStep();
      this.track.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    setupIndicator() {
      if (!this.indicatorContainer) return;

      const dotCount = this.getMaxIndex() + 1;
      this.indicatorContainer.innerHTML = '';

      if (dotCount <= 1) {
        this.indicatorContainer.style.display = 'none';
        this.dots = [];
        return;
      }

      this.indicatorContainer.style.display = 'flex';

      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('div');
        dot.className = 'pmc__dot';
        dot.dataset.index = i;
        dot.addEventListener('click', () => {
          this.scrollToCard(i);
          this.pauseAutoplayTemporarily();
        });
        this.indicatorContainer.appendChild(dot);
      }

      this.dots = Array.from(this.indicatorContainer.querySelectorAll('.pmc__dot'));
    }

    updateIndicator() {
      if (!this.dots || this.dots.length === 0) return;
      const current = this.getCurrentCardIndex();
      const clamped = Math.max(0, Math.min(current, this.getMaxIndex()));
      this.dots.forEach((dot, i) => dot.classList.toggle('active', i === clamped));
      this.scrollIndex = clamped;
    }

    setupScrollListener() {
      let timeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => this.updateIndicator(), 80);
      }, { passive: true });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.setupIndicator();
          this.updateIndicator();
        }, 200);
      });
    }

    setupInteractionListeners() {
      ['touchstart', 'mousedown'].forEach((evt) => {
        this.track.addEventListener(evt, () => {
          this.isUserInteracting = true;
          this.stopAutoplay();
        }, { passive: true });
      });

      ['touchend', 'mouseup'].forEach((evt) => {
        this.track.addEventListener(evt, () => {
          this.isUserInteracting = false;
          this.pauseAutoplayTemporarily();
        }, { passive: true });
      });
    }

    pauseAutoplayTemporarily() {
      this.stopAutoplay();
      clearTimeout(this.interactionTimeout);
      this.interactionTimeout = setTimeout(() => this.startAutoplay(), 3000);
    }

    startAutoplay() {
      const enabled = this.getAttribute('data-autoplay-enabled') === 'true';
      if (!enabled || this.totalCards <= this.getVisibleCount()) return;

      this.stopAutoplay();

      const speed = parseInt(this.getAttribute('data-autoplay-speed')) || 5;
      this.autoplayTimer = setInterval(() => {
        if (this.isUserInteracting) return;
        let next = this.scrollIndex + 1;
        if (next > this.getMaxIndex()) next = 0;
        this.scrollToCard(next);
      }, speed * 1000);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define('pm-ai-carousel', PuffmartCarousel);
})();
